__turbopack_context__.v({
  "layout1": "F2-w1G_layout1",
  "layout2": "F2-w1G_layout2",
  "layout3": "F2-w1G_layout3",
});
